import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { DeletionJobStatus } from "@/types/data-deletion";

type BadgeVariant = React.ComponentProps<typeof Badge>["variant"];

const STATUS_VARIANT: Record<DeletionJobStatus, BadgeVariant> = {
  PENDING: "new_secondary",
  RUNNING: "status_in_progress",
  COMPLETED: "status_done",
  FAILED: "new_destructive",
  CANCELLED: "new_secondary",
};

interface DeletionStatusBadgeProps {
  status: DeletionJobStatus;
  className?: string;
}

export const DeletionStatusBadge: React.FC<DeletionStatusBadgeProps> = ({
  status,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <Badge variant={STATUS_VARIANT[status]} className={className}>
      {t(`dataDeletion.status.${status}`)}
    </Badge>
  );
};
